import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Page from 'Core/components/Page';
import Card from 'Core/components/FormElements/Card';
import { createSecondaryFinancingPath } from 'Modules/financing/routes';
import { BiError } from 'react-icons/bi';

import { PrimaryButton } from 'Core/components/Button';
import { useNavigate } from 'react-location';
import classNames from 'classnames';
import PostExchangeBanner from 'Modules/financing/components/PostExchangeBanner';

export default function FinancingDeclined({ allowCreateApplication = false, application = {} }) {
  document.title = 'Payment Portal - Application Declined';
  const { t } = useTranslation();
  useScrollTop();

  const navigate = useNavigate();
  const { customer_id = '', payload: { relationship = '' } = {} } = application;
  const handleCreateApplication = () => {
    const relationshipObj = JSON.stringify({ relationship, customer_id });
    sessionStorage.setItem('relationship', relationshipObj);
    navigate({
      to: createSecondaryFinancingPath,
      search: true,
    });
  };
  const descriptionLabel = allowCreateApplication
    ? 'synchrony.nextgen.declined.introWithNewApp'
    : 'synchrony.nextgen.declined.intro';

  return (
    <Page title={t('page.financing.header')} withStepProgress={false} stickyFooter>
      <div className="mx-auto max-w-4xl px-4 mt-10">
        <PostExchangeBanner application={application} />

        <Card className="relative overflow-hidden !px-0 !py-0" cardPadding="sm">
          <div className="h-1 bg-red-500" />

          <div className="px-8 md:px-14 pt-12 pb-12">
            <div className="flex justify-center">
              <div
                aria-hidden="true"
                className="flex items-center justify-center h-14 w-14 rounded-full bg-red-50 ring-1 ring-red-100"
              >
                <BiError className="h-7 w-7 text-red-600" />
              </div>
            </div>

            <h1
              className="mt-6 text-center text-3xl md:text-[2rem] font-semibold tracking-tight text-slate-900 leading-tight"
              data-testid="title-finance-declined"
            >
              {t('common.nextgen.financingDeclined.title')}
            </h1>

            <div aria-hidden="true" className="mt-7 h-[3px] w-full rounded-full bg-red-300" />

            <div
              className={classNames(
                'mt-7 mx-auto max-w-2xl text-center whitespace-pre-line text-base md:text-lg leading-relaxed text-slate-600'
              )}
            >
              {t(descriptionLabel)}
            </div>

            {allowCreateApplication && (
              <div className="mt-10 flex justify-center">
                <PrimaryButton
                  data-testid="btn-create-secondary-application"
                  size="tall"
                  rounded
                  className="!px-12"
                  onClick={handleCreateApplication}
                >
                  {t('common.reapply')}
                </PrimaryButton>
              </div>
            )}
          </div>
        </Card>
      </div>
    </Page>
  );
}
